import React from "react";
import "./Footer.css";
import { COPYRIGHT_MESSAGE } from "../../../utils/constants/GlobalConstants";

const Footer = () => {
  return (
    <div className="footer-copyright">
      <div className="content">
        <p>{COPYRIGHT_MESSAGE}</p>
      </div>
    </div>
  );
};
export default Footer;
